import Api from "./Api.ts";

export const getAllFares = async () => {
    const response = await Api.get("/fare/all");
    return response.data;
  };
  
